/**
 * Created by Abner Sui on 05/08/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { BriefConfig } from '../../widgets/widgets.model';
import { EmailDigestSubChromeEventTypes } from './email-digest-editor.model';

@Component({
    selector: 'tam-email-digest-editor-sub-chrome',
    templateUrl: './email-digest-editor-sub-chrome.component.html',
    styleUrls: ['./email-digest-editor-sub-chrome-component.scss']
})
export class EmailDigestEditorSubChromeComponent implements OnInit, OnDestroy {

    @Input() config: BriefConfig;
    @Input() name: string;
    isProgressing = false;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor() { }

    ngOnInit() { }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    onCancel() {
        this.config.feedbackSubject$.next({
            type: EmailDigestSubChromeEventTypes.CANCEL,
        });
    }

    onSave() {
        // TODO should add a listener for get save status.
        // this.isProgressing = true;
        this.config.feedbackSubject$.next({
            type: EmailDigestSubChromeEventTypes.SAVE,
        });
    }

}
